module.exports = __webpack_public_path__ + "img/sections-inactive-tab.e3768728.svg";